<template>
    <rkm-overlay>
        <rkm-layout-body title="Dispensação de medicamento">

            <rkm-layout-content>
                <List @redirectRelatorio="redirectRelatorio" :relatorio="relatorio">
                    <template #actions="{ item }">
                        <rkm-button
                            @click="redirectToDispensacao(item)"
                            class="align-self-end"
                            color="primary"
                            small
                            title="Dispensar"
                        >
                            <rkm-icon icon="hand-holding-medical" />
                        </rkm-button>
                    </template>
                </List>
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// import List from '@/components/cadastro/paciente/components/busca/List'
import List from '@/components/farmacia/dispensacao/List'

// Vuex
import { mapActions } from 'vuex';

// Enums.
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'

// Mixins.
import { repository, error, stringCase } from '@/mixins'

export default {
    components: { List },
    created() {

        this.repositories = {
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        }
    },
    data: () => ({
        enums: {
            subclassificacao,
        },
    }),
    methods: {
        ...mapActions([
            'setLoading',
            'unsetLoading'
        ]),
        redirectToDispensacao(paciente) {

            this.setLoading()

            this.repositories.paciente.validCNS(this.camelObjectKeysToSnakeRecursive({pacienteId: paciente.id}))
                .then(response => {

                    if (!response.data.additionals.cnsValido && response.data.additionals.avisaCnsTemporarioInvalido) {

                        this.showWarningNotification('Paciente com CNS inválido. Registro não permitido.')
                        return false
                    }

                    if (paciente.subclassificacaoId === this.enums.subclassificacao.TEMPORARIO
                        && response.data.additionals.avisaCnsTemporarioInvalido) {

                        const confirm = async () => {

                            this.$router.push({ name: 'farmacia-dispensacao-create', params: { pacienteId: paciente.id }})

                            return false
                        }

                        const msg = `Paciente com cadastro temporário. Deseja continuar?`

                        this.showConfirmation(msg, confirm)

                        return false
                    }

                    if (paciente.diasCadastroDesatualizado > 0) {

                        const confirm = async () => {

                            this.$router.push({ name: 'farmacia-dispensacao-create', params: { pacienteId: paciente.id }})

                            return false
                        }

                        const msg = `Paciente com cadastro desatualizado há <strong>${paciente.diasCadastroDesatualizado}</strong>
                            dia(s). Deseja continuar?`

                        this.showConfirmation(msg, confirm)

                        return false
                    }

                    this.$router.push({ name: 'farmacia-dispensacao-create', params: { pacienteId: paciente.id }})
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        redirectRelatorio() {

            this.$router.push({ name: 'almoxarifado-relatorio-validade-material-index', params: { dispensacao: true }})
        },
    },
    mixins: [ repository, error, stringCase ],
    props: {
        relatorio: { type: Boolean, default: true }
    },
}
</script>